import store from './store/index';

const login = function () {

};

const logout = function () {
  return store.dispatch('logoutUser');
};

const getToken = function () {
  return store.state.auth.user ? store.state.auth.user.auth_token : null;
};

const getUser = function () {
  return store.state.auth.user;
};

const getRole = function () {
  return store.state.auth.permissions.role;
};

const isLoggedIn = function () {
  return store.state.auth.logged;
};

const isProfileConfirmed = function () {
  return store.state.auth.user && store.state.auth.user.extra ? store.state.auth.user.extra.profile_confirmed : false;
};

export default {
  login,
  logout,
  isLoggedIn,
  isProfileConfirmed,
  getToken,
  getUser,
  getRole,
};



// WEBPACK FOOTER //
// ./src/authManager.js